/* eslint-disable no-param-reassign */

export default (function (colors, array, prefix) {
  return array.forEach(function (color, index) {
    colors[prefix + "-" + (index + 1)] = color;
  });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/themes/colorsFromArray.js
// module id = 49
// module chunks = 0